<template>
  <div :class="$style.container">
    <feather-icon :class="$style.menuButton" icon="MenuIcon" @click.stop="showSidebar" />

    <div :class="$style.buildings" v-click-outside="onClickOutsideHouses">
      <div :class="$style.address" @click="onClickHouses">
        {{ selectedHouseAddress }}
        <app-icon :class="$style.addressIcon" name="ChevronDown" size="20px" />
      </div>
      <div :class="$style.city">{{ selectedHouseCity }}</div>

      <div :class="[$style.dropdown, $style.buildingsDropdown, housesActive && $style.dropdownActive]">
        <transition duration="500">
          <houses-select-list v-if="housesActive" />
        </transition>
      </div>
    </div>
    <div :class="$style.aside">
      <div :class="$style.user" v-click-outside="onClickOutsideSettings" @click="onClickSettings">
        <div :class="$style.name">{{ username }}</div>
        <button :class="$style.settingsButton">
          <app-icon :class="$style.settingsIcon" name="SettingsIcon" size="16px" />
        </button>
      </div>

      <div :class="[$style.dropdown, $style.settingsDropdown, settingsActive && $style.dropdownActive]">
        <div :class="$style.setting">
          <span>Повышенная контрастность</span>
          <app-switch v-model="isAppContrast" />
        </div>
        <vs-button type="border" icon-pack="feather" icon="icon-log-out" @click="logout">Выход</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import HousesSelectList from "@/layouts/components/HousesSelectList";
import { mapGetters }   from "vuex";

export default {
  name:       "TheHeader",
  components: { HousesSelectList },
  data() {
    return {
      housesActive:   false,
      settingsActive: false,
    };
  },

  computed: {
    selectedHouse() {
      return this.$store.getters['appUser/selectedHouse'];
    },

    selectedHouseAddress() {
      const { street, house } = this.selectedHouse;
      return `${street}, ${house}`;
    },

    selectedHouseCity() {
      return this.selectedHouse.city;
    },

    isAppContrast: {
      get() {
        return this.$store.getters['highContrast'];
      },
      set( v ) {
        this.$store.dispatch('UPDATE_HIGH_CONTRAST', v);
      },
    },

    houses() {
      return this.$store.getters['appUser/housesGroups'];
    },

    ...mapGetters('appUser', {
      username: 'name',
    }),
  },
  methods:  {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },

    onClickOutsideSettings() {
      this.settingsActive = false;
    },

    onClickSettings() {
      this.settingsActive = !this.settingsActive;
    },

    onClickOutsideHouses() {
      this.housesActive = false;
    },

    onClickHouses() {
      this.housesActive = !this.housesActive;
    },

    logout() {
      return this.$store.dispatch('appUser/LOGOUT');
    },
  },
  watch:    {
    selectedHouse() {
      this.housesActive = false;
    },
  },
};
</script>

<style lang="scss" module>
$mobileBreakpoint: 1199px;

.container {
  height: 80px;
  background: #FFFFFF;
  margin: 1em 1em 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  z-index: 1000;
  @include max-width($mobileBreakpoint) {
    height: 64px;
  }
}

.menuButton {
  cursor: pointer;
  margin-right: 30px;
  display: none;
  @include max-width($mobileBreakpoint) {
    display: block;
  }
}

.buildings {
  position: relative;
}

.aside {
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-left: 1em;
  position: relative;
  z-index: 1;
}

.name {
  font-size: 1.2em;
  //font-weight: bold;
  margin-right: 1em;
  text-align: right;
  line-height: 1;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  @include max-width($mobileBreakpoint) {
    font-size: 1em;
  }
}

.user {
  position: relative;
  display: flex;
  align-items: center;
}

.settingsButton {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid color(content-color);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @include anim(.1s);

  &:hover {
    background: color(primary);
    border-color: color(primary);
    color: #ffffff;
  }
}

.settingsIcon {
  @include anim(.1s);
}

.dropdown {
  position: absolute;
  top: 100%;
  margin-top: 10px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 25px 0 rgba(#000, .1);
  border: 1px solid rgba(#000, .1);
  opacity: 0;
  z-index: -1;
  transform: translateY(10px);
  pointer-events: none;
  visibility: hidden;
  @include anim(.1s);

  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: #fff;
    left: 15px;
    top: 0px;
    transform: rotate(45deg) translate(-7px);
    border-top: 1px solid rgba(0, 0, 0, .1);
    border-left: 1px solid rgba(0, 0, 0, .1);
  }
}

.dropdownActive {
  opacity: 1;
  transform: none;
  pointer-events: all;
  visibility: visible;
  z-index: 1;
}

.setting {
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  margin-bottom: 1.5em;

  span {
    margin-right: .5em;
  }
}

.settingsDropdown {
  left: auto;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  padding: 1em;

  &:after {
    left: auto;
    right: 4px;
  }
}

.address {
  position: relative;
  font-size: 1.4em;
  line-height: 1;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @include max-width($mobileBreakpoint) {
    font-size: 1.1em;
  }
}

.addressIcon {
  width: 18px;
  height: 18px;
  margin-left: .5em;
  vertical-align: middle;
}

.city {
  margin-top: .5em;
  opacity: .5;
  @include max-width($mobileBreakpoint) {
    font-size: .9em;
    margin-top: 0;
  }
}

.buildingsDropdown {
  max-height: calc(100vh - 150px);
  //max-width: calc(100vw - 120px);
  display: flex;
}
</style>
